import { ConnectedInPersonLayout } from "./in-person-layout";
import { ConnectedVirtualLayout } from "./virtual-layout";
export const DefaultLayouts = {
    virtual: ConnectedVirtualLayout,
    'in-person': ConnectedInPersonLayout
};
